<div class="input-group my-custom-tooltip" [ngClass]="{'margin-top-20':field.key == 'costCentreCode1'}">
  <!-- <input  id="{{ fieldKey }}" type="text" class="form-control searchField padding-right-30" readonly
    [formControl]="formControl" [formlyAttributes]="field"
    [ngClass]="{'has-value': formControl.value, 'padding-left-20': field.key === 'preApprovalTag', 'color-light-grey-disabledType': to.disabled, 'ai-scanned-input': field.templateOptions.isAiScannedValue}"
    (click)="fnOpenSelectionPanel()">
  <label for="InputPanel" class="w-100pc">{{field.templateOptions.label}}<span *ngIf="field.templateOptions.required">*</span>
     <span class="ml-2  " *ngIf="field.key == 'vatNoVatReceiptType' && model.isFmEditingExpense">
       <i class="fas fa-info-circle text-mustard" ngbTooltip ="{{ 'fm_receipt_type_not_editable_note' | translate }}"  placement="right"></i>
     </span>
  </label> -->

  <ds-textbox   
    [formControl]="formControl" 
    [formlyAttributes]="field"
    [textboxInput]="textboxConfig"
    (click)="fnOpenSelectionPanel()">
  </ds-textbox>
   

  <!-- <span class="icons z-0" (click)="fnOpenSelectionPanel()">
    <a><i class="fas fa-chevron-circle-right text-logo-blue" aria-hidden="true"></i></a>
  </span> -->

  <span *ngIf="model.isPolicyAvailable && field.key == 'expenseCategoryName' && model.orgExpenseCategoryId > 0">
    <a (click)="fnShowExpPolicy()">
      <small class="d-inline-block w-100pc text-right cursor-pointer text-logo-blue text-underline">
        {{ "label_ViewExpensePolicy" | translate }}
      </small>
    </a>
  </span>
  <span *ngIf="claims?.orgRoleId == userTypeEnum.FinanceManager && field.key == 'vatNoVatReceiptType'">
    <a (click)="fnOpenReceiptTypePanel()">
      <small class="d-inline-block w-100pc text-right cursor-pointer text-logo-blue text-underline">
       {{ "self_setup_16_msg_19" | translate }}
      </small>
    </a>
  </span>

  <span *ngIf="field.key == 'costCentreCode1' && !claims.isCostCentreOn">
    <a (click)="fnOpenCostCentrePanel()">
      <small class="d-inline-block w-100pc text-right cursor-pointer text-logo-blue text-underline">
        {{ "self_setup_16_msg_20" | translate }}
      </small>
    </a>
  </span>
  <p  class="text-left f-11 font-weight-bold cursor-pointer" 
    *ngIf="field.templateOptions.supportingNote" (click)="fnOpenSupportingNotePanel()">
    <span class="" [innerHTML]="sanitizerHtml(field.templateOptions.supportingNote)" ></span>             
   </p>

  <span class="position-absolute left-0px top-8px text-mustard"
    *ngIf="field.key === 'preApprovalTag' && formControl.value">
    <i class="fas fa-link"></i>
  </span>
  <p class="fw-600" *ngIf="field.key === 'preApprovalTag' && formControl.value"
    [ngClass]="{'color-red': model.preApprovalBalance < 0 }">
    {{ 'pre_approval_balance' | translate }}: {{model.preApprovalBalance| number: "1.2-2"}}
  </p>

  <p class="fw-100 f-11" *ngIf="field.key === 'derivedName' && formControl.value">
    {{ 'registration_number' | translate }}:
    {{fnReturnRegNum(model.mileage.registrationNumber)}}{{fnReturnMakeModel(model.mileage.makeModel)}}
  </p>

  <div *ngIf="formControl.errors && formControl.errors.required && isFormSubmitted" class="alert-danger">
    <span *ngIf="!formControl.value || !formControl.value.trim()">
      <b>{{ "label_Required" | translate }}</b>
    </span>
  </div>
  <div *ngIf="field.templateOptions.isAiScannedValue" class="ai-scanned-label">
    <img src="../../../../../assets/svg-icons/ai.svg" alt="ai" class="required-icon">
    <span>{{ 'label_ai_scanned_values' | translate }}</span>
  </div>
</div>

<!-- Panels -->
<select-category-panel *ngIf="showSelectExpenseCategoryPanel" [inputData]="inputModel"
  (closePanelEvent)="closeSelectionPanel($event)" (selectItemEvent)="onSelection($event)">
</select-category-panel>

<select-pre-approval-tag-panel *ngIf="showSelectPreApprovalTagPanel" [inputData]="inputModel"
  (closePanelEvent)="closeSelectionPanel($event)" (selectItemEvent)="onSelection($event)">
</select-pre-approval-tag-panel>

<select-foreign-currency-panel *ngIf="showSelectForeignCurrencyPanel" [inputData]="inputModel"
  (closePanelEvent)="closeSelectionPanel($event)" (selectItemEvent)="onSelection($event)">
</select-foreign-currency-panel>

<select-state-panel *ngIf="showSelectStatesPanel" [inputData]="inputModel"
  (closePanelEvent)="closeSelectionPanel($event)" (selectItemEvent)="onSelection($event)">
</select-state-panel>

<select-business-purpose-panel *ngIf="showSelectBusinessPurposePanel" [inputData]="inputModel"
  (closePanelEvent)="closeSelectionPanel($event)" (selectItemEvent)="onSelection($event)">
</select-business-purpose-panel>

<select-additional-field-data-panel *ngIf="showSelectAdditionalFieldDataPanel" [inputData]="inputModel"
  (closePanelEvent)="closeSelectionPanel($event)" (selectItemEvent)="onSelection($event)">
</select-additional-field-data-panel>

<view-exp-policy-panel *ngIf="showExpensePolicyPanel" [inputData]="showPolicyInputModel"
  (closePanelEvent)="closeSelectionPanel($event)">
</view-exp-policy-panel>

<select-customer-panel *ngIf="showSelectCustomerPanel" [inputData]="inputModel"
  (closePanelEvent)="closeSelectionPanel($event)" (selectItemEvent)="onSelection($event)">
</select-customer-panel>

<select-project-panel *ngIf="showSelectProjectPanel" [inputData]="inputModel"
  (closePanelEvent)="closeSelectionPanel($event)" (selectItemEvent)="onSelection($event)">
</select-project-panel>

<select-cost-centre-panel *ngIf="showSelectCostCentrePanel" [inputData]="inputModel"
  (closePanelEvent)="closeSelectionPanel($event)" (selectItemEvent)="onSelection($event)">
</select-cost-centre-panel>

<select-cost-centre-panel *ngIf="showSelectCostCentreForEmployeePanel" [inputData]="inputModel"
 [(fmSpecialObject)]="fmSpecialObject"
  (closePanelEvent)="closeSelectionPanel($event)" (selectItemEvent)="onSelection($event)">
</select-cost-centre-panel>

<select-location-panel *ngIf="showSelectLocationPanel" [inputData]="inputModel"
  (closePanelEvent)="closeSelectionPanel($event)" (selectItemEvent)="onSelection($event)">
</select-location-panel>

<select-receipt-type-panel *ngIf="showSelectReceiptTypePanel" [inputData]="inputModel"
  (closePanelEvent)="closeSelectionPanel($event)" (selectItemEvent)="onSelection($event)">
</select-receipt-type-panel>

<app-select-vehicle-panel *ngIf="showVehiclePanel" [inputData]="inputModel"
  (closePanelEvent)="closeSelectionPanel($event)" (selectItemEvent)="onSelection($event)">
</app-select-vehicle-panel>
<app-alert-panel [data]="alertPanelModel" (callbackEvent)="alertPanelReceiver($event)">
</app-alert-panel>

<container-list-panel *ngIf="showContainerListPanel" [inputData]="inputModel"
  (closePanelEvent)="closeSelectionPanel($event)" (submitPanelEvent)="onSelection($event)">
 </container-list-panel>

 <select-company-panel *ngIf="showCompanyListPanel" [inputData]="inputModel"
  (closePanelEvent)="closeSelectionPanel($event)" (selectItemEvent)="onSelection($event)"></select-company-panel>
<vendor-category-list-panel *ngIf="showVendorCategoriesPanel" [inputData]="inputModel"
  (closePanelEvent)="closeSelectionPanel($event)" (submitPanelEvent)="onSelection($event)"></vendor-category-list-panel>
<vendor-brand-mapping-panel *ngIf="showVendorBrandMappingPanel" [inputData]="inputModel"
  (closePanelEvent)="closeSelectionPanel($event)" (submitPanelEvent)="onSelection($event)"></vendor-brand-mapping-panel>

<select-brand-panel *ngIf="showBrandPanel" [inputData]="inputModel"
  (closePanelEvent)="closeSelectionPanel($event)" (submitPanelEvent)="onSelection($event)">
</select-brand-panel>
<select-vendor-category-panel *ngIf="showSelectVendorCategoryPanel" [inputData]="inputModel"
  (closePanelEvent)="closeSelectionPanel($event)" (selectItemEvent)="onSelection($event)">
</select-vendor-category-panel>